<sc-padding>
  <sc-hint-legacy dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-select-gate-title-name-label"></sc-hint-legacy>
  <div>{{areaGate.name}}</div>
</sc-padding>
